// extracted by mini-css-extract-plugin
module.exports = {"metricsSection":"index-module--metricsSection--28uFe","metricsCol":"index-module--metricsCol--1aR59","metricsOuter":"index-module--metricsOuter--1ORkQ"};